import { FC, useState } from "react";
import { useDispatch } from "react-redux";

import { Box, Button, Card, Divider, Stack } from "@mui/material";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import AssistantOutlinedIcon from "@mui/icons-material/AssistantOutlined";
import DirectionsBusOutlinedIcon from "@mui/icons-material/DirectionsBusOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import RouteIcon from "@mui/icons-material/Route";

import { LAYOUT_MARGIN } from "Configs/home";
import { MenuStatus } from "Types/menu";

import { useAppSelector } from "Hooks/useRedux";

import { changeMenu } from "Redux/menuSlice";
import { clear } from "Redux/singleLocationSlice";

import Paths from "../Lists/Paths";
import Profile from "../Lists/Profile";
import Stations from "../Lists/Stations";
import Survey from "../Lists/Survey";

interface IMenuItem {
  id: MenuStatus;
  icon: any;
  content: FC;
}

const MenuItems: IMenuItem[] = [
  { id: "survey", icon: AssistantOutlinedIcon, content: Survey },
  { id: "stations", icon: DirectionsBusOutlinedIcon, content: Stations },
  { id: "paths", icon: RouteIcon, content: Paths },
  { id: "profile", icon: AccountCircleOutlinedIcon, content: Profile },
];
const AnimationTime = 600;

export default function Menu() {
  const { status } = useAppSelector((state) => state.menu);
  const { visibleType } = useAppSelector((state) => state.singleLocation);

  const [activeMenu, setActiveMenu] = useState<MenuStatus>("disable");

  const dispatch = useDispatch();

  // Logic functions
  const handleToggleMenu = (input: MenuStatus) => {
    if (input === "disable") {
      setTimeout(() => {
        setActiveMenu("disable");
      }, AnimationTime);
    } else {
      setActiveMenu(input);
    }
    dispatch(changeMenu(input));
  };

  // UI functions
  const renderMenuItems = () =>
    MenuItems.map((item, index) => {
      const Icon = item.icon;

      return (
        <>
          <Button
            variant="white"
            size="large"
            aria-describedby={`item-${index}`}
            sx={{ borderRadius: 0, boxShadow: 0, "&:hover": { boxShadow: 0 } }}
            onClick={() => handleToggleMenu(item.id)}
          >
            <Icon />
          </Button>

          {index + 1 < MenuItems.length && <Divider />}
        </>
      );
    });

  const ActiveMenuContent = MenuItems.filter((item) => item.id === activeMenu)[0]?.content;

  return (
    <>
      <Button
        variant="contained"
        color="error"
        size="large"
        sx={{ p: 0, mb: "10px", display: visibleType === "" ? "none" : "inline-flex" }}
        onClick={() => dispatch(clear())}
      >
        <CloseOutlinedIcon />
      </Button>
      <Card sx={{ mr: `${LAYOUT_MARGIN}px`, bgcolor: "transparent" }} component={Stack}>
        {renderMenuItems()}
      </Card>
      <Box
        sx={{
          position: "fixed",
          right: "0",
          top: "50%",
          transform: "translateY(-50%)",
          bgcolor: "common.white",
          width: "100vw",
          height: "100vh",
          transition: `all ${AnimationTime / 1000}s cubic-bezier(0.645, 0.045, 0.355, 1.000)`,
          // clipPath: "circle(80%)",
          clipPath: `circle(${status === "disable" ? `10px at -100px 50%` : "75%"})`,
          p: "60px",
        }}
      >
        {activeMenu !== "disable" && <ActiveMenuContent />}
      </Box>
    </>
  );
}
